import type { ExcelColumnMapping } from './types';
import type { PhieuChi } from '@/types/schemas';
import { formatDate } from '@/lib/formatUtils';

export type PhieuChiExportRow = PhieuChi;

export const PHIEU_CHI_COLUMNS: ExcelColumnMapping<PhieuChiExportRow>[] = [
  { header: 'Trạng thái', width: 12, resolver: row => row.status ?? '' },
  { header: 'Số c/từ', width: 18, resolver: row => row.so_ct ?? '' },
  {
    header: 'Ngày c/từ',
    width: 14,
    resolver: row => formatDate(row.ngay_ct ?? '')
  },
  { header: 'Người nhận', width: 24, resolver: row => row.ong_ba ?? '' },
  { header: 'Diễn giải', width: 30, resolver: row => row.dien_giai ?? '' },
  { header: 'Tk có', width: 12, resolver: row => row.tk_data?.code ?? '' },
  { header: 'Tổng tiền', width: 18, resolver: row => Number(row.t_tien ?? 0) },
  { header: 'Ngoại tệ', width: 12, resolver: row => row.ma_nt_data?.ma_nt ?? '' },
  { header: 'Loại giao dịch', width: 18, resolver: row => row.ma_ngv ?? '' }
];
